import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {
  IPopulate,
  IQueryParam,
  ILuminaria,
  IFilter,
  IReporteLuminariaWellness,
  IDispositivoLuminariaGPE,
  IReporteLuminariaGPE,
  IGeoJSONPoint,
  IReporteLuminariaACTISEnergia,
  IReporteLuminariaACTISEstado,
  IEventoGenerico,
  IDispositivoLuminariaACTIS,
  IReporteLuminariaGPEEnergia,
  NivelObjetivo,
} from 'modelos/src';
import { Subscription, firstValueFrom } from 'rxjs';
import { LuminariasHttpService } from '../../../../../auxiliares/servicios/http/luminarias.service';
import { ActivatedRoute, Router } from '@angular/router';
import {
  IColumnas,
  ICrearBoton,
  IExportarBoton,
} from '../../../../../auxiliares/tabla/tabla.component';
import {
  IFiltroTabla,
  IRegExpSearch,
} from '../../../../../auxiliares/tabla/filtro/filtro.component';
import { DialogService } from '../../../../../auxiliares/dialog/dialog.service';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import { LoginService } from '../../../../login/login.service';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';
import { LuminariasService } from '../../service';
import { ImportarUbicacionesComponent } from '../importar-ubicaciones/importar-ubicaciones.component';
import { ILuminariaExtendida } from '../../luminarias.types';
import { ReportesGenericosService } from '../../../../../auxiliares/servicios/http/reportes-genericos.service';
import { EventosGenericosHttpService } from '../../../../../auxiliares/servicios/http/eventos-genericos.service';
import { ConfigsDeseadasService } from '../../../../../auxiliares/servicios/http/configs-deseadas.service';
import { filtrarComandosManuales } from '../../../../../auxiliares/comandos-manuales.util';

import { CambiarClienteComponent } from '../../../../standalone/cambiar-cliente/cambiar-cliente.component';
import { ExportarLuminariasDialogComponent } from '../exportar-luminarias-dialog/exportar-luminarias-dialog.component';
import { DescargasService } from '../../../../navigation/descargas/service';
import {
  CodigoEstadoLuminaria,
  estadoLuminariaCelda,
  presentacionEstado,
} from '../../estado/estado-luminaria';
import {
  CrearEditarEventoTecnicoGenericoComponent,
  ICrearEditarEventoTecnicoGenericoData,
} from '../../../eventos-genericos/eventos-tecnicos-genericos/crear-editar/crear-editar-evento-tecnico-generico.component';
import { ClienteJerarquiaService } from '../../../../../auxiliares/servicios/cliente-jerarquia.service';
import { escaparHtml } from '../../../../../auxiliares/html-seguro.util';
import { FormularioDialogService } from '../../../../../auxiliares/servicios/formulario-dialog.service';
import { nivelPerfil } from '../../../../../auxiliares/iconos/iconos';
import { IEstadoCelda } from '../../../../../auxiliares/tabla/tabla.interfaces';
import {
  barraHtml,
  estadoHtml,
  fechaCelda,
  haceCelda,
} from '../../../../../auxiliares/tabla/celdas';

/** Modo de encendido → ícono (docs/ICONOS.md §4). «Manual» no tiene. */
const ICONO_MODO: Record<string, string> = {
  Astronómico: 'wb_twilight',
  Fotocélula: 'wb_sunny',
};

interface IMedicionesElectricas {
  potencia?: number;
  voltaje?: number;
  consumoAcum?: number;
  corriente?: number;
  fp?: number;
  unidadCorriente: string;
}

/**
 * Últimas mediciones eléctricas según el tipo de equipo. Wellness reporta
 * corriente en A (potencia = V×A = W); GPE/ACTIS en mA.
 */
function medicionesElectricas(
  dato: ILuminariaExtendida,
): IMedicionesElectricas | null {
  const tipo = dato?.dispositivo?.tipo;
  if (tipo === 'Luminaria Wellness') {
    const w = dato?.ultimoReportePeriodico?.valores as any;
    const voltaje: number | undefined = w?.voltage;
    const corriente: number | undefined = w?.current;
    return {
      voltaje,
      corriente,
      potencia:
        voltaje != null && corriente != null ? voltaje * corriente : undefined,
      consumoAcum: w?.reactivePowerTotal,
      fp: w?.factorPotencia,
      unidadCorriente: 'A',
    };
  }
  if (tipo === 'Luminaria GPE' || tipo === 'Luminaria ACTIS FING') {
    const energia = dato?.ultimoReporteEnergia?.valores as any;
    return {
      voltaje: energia?.voltaje,
      potencia: energia?.potencia,
      consumoAcum: energia?.energiaTotal,
      corriente: energia?.corriente,
      fp: energia?.factorPotencia,
      unidadCorriente: 'mA',
    };
  }
  return null;
}

/** Hasta 2 decimales, sin «,00» en los enteros. */
function formatoElectrico(n: number | undefined): string | null {
  return n != null && isFinite(n)
    ? n.toLocaleString('es-AR', { maximumFractionDigits: 2 })
    : null;
}

@Component({
  selector: 'app-listado-luminarias',
  templateUrl: './listado-luminarias.component.html',
  styleUrl: './listado-luminarias.component.scss',
  standalone: false,
})
export class ListadoLuminariasComponent implements OnInit, OnDestroy {
  private formularios = inject(FormularioDialogService);
  helper = inject(HelperService);
  private clienteJerarquia = inject(ClienteJerarquiaService);
  private dialogService = inject(DialogService);
  private service = inject(LuminariasHttpService);
  private navigator = inject(Router);
  private route = inject(ActivatedRoute);
  luminariasHttpService = inject(LuminariasHttpService);
  private descargas = inject(DescargasService);
  lista2 = inject(Lista2Service);
  luminariasService = inject(LuminariasService);
  reportesGenericosService = inject(ReportesGenericosService);
  private eventosService = inject(EventosGenericosHttpService);
  private configsDeseadasService = inject(ConfigsDeseadasService);

  public loading = false;
  public clientePropio = LoginService.getCliente();
  //// Tabla nueva
  public name = 'ListadoLuminariasComponent';
  public luminarias?: ILuminariaExtendida[];
  public totalCount = 0;
  public columnas?: IColumnas<ILuminariaExtendida>[];

  //Subs
  public luminarias$?: Subscription;
  //

  public botonCrear: ICrearBoton = {
    mostrar: this.helper.tienePermiso('Luminarias - Crear'),
    tooltip: 'Crear luminaria',
    color: 'primary',
    tipo: 'material',
    icon: 'add',
    accion: () => this.crear(),
  };

  // Sólo lo ve el admin nivel 0
  public botonImportar: IExportarBoton = {
    mostrar: this.helper.tienePermiso('Luminarias - Crear'),
    tooltip: 'Importar ubicaciones',
    color: 'primary',
    tipo: 'material',
    icon: 'upload_file',
    accion: () => this.abrirImportador(),
  };

  // Exportación general a Excel (todas las luminarias del scope/filtros activos).
  public botonExportar: IExportarBoton = {
    mostrar: true,
    tooltip: 'Exportar a planilla',
    color: 'primary',
    tipo: 'material',
    icon: 'table_view',
    accion: () => this.exportar(),
  };

  //Buscar
  public search: IRegExpSearch = {
    fields: ['identificacion', 'direccion', 'deveui'],
  };

  // FILTROS
  //Cliente
  public cliente: IFiltroTabla = {
    filter: {
      field: 'idCliente',
    },
    label: 'Cliente',
    tipo: 'cliente-selector',
    filtroSelector: ['moduloLuminarias'],
  };
  // Cliente en cuya jerarquía cuelga la entidad: el cliente elegido y toda su
  // descendencia.
  public ancestro: IFiltroTabla = {
    filter: {
      field: 'idsAncestros',
      incluirPropio: true,
    },
    label: 'En la jerarquía de',
    tipo: 'cliente-selector',
  };

  //Fecha Última Comunicación
  private now = new Date();
  private fechaUltimaComunicacion: IFiltroTabla = {
    elementos: [
      {
        label: 'Últimas 24 horas',
        value: [
          {
            fechaUltimaComunicacion: {
              $gte: new Date(
                this.now.getTime() - 24 * 60 * 60 * 1000,
              ).toISOString(),
            },
          },
        ],
      },
      {
        label: 'Más de 1 día',
        value: [
          {
            fechaUltimaComunicacion: {
              $lt: new Date(
                this.now.getTime() - 24 * 60 * 60 * 1000,
              ).toISOString(),
            },
          },
        ],
      },
      {
        label: 'Más de 2 días',
        value: [
          {
            fechaUltimaComunicacion: {
              $lt: new Date(
                this.now.getTime() - 2 * 24 * 60 * 60 * 1000,
              ).toISOString(),
            },
          },
        ],
      },
      {
        label: 'Más de 1 semana',
        value: [
          {
            fechaUltimaComunicacion: {
              $lt: new Date(
                this.now.getTime() - 7 * 24 * 60 * 60 * 1000,
              ).toISOString(),
            },
          },
        ],
      },
      {
        label: 'Más de 1 mes',
        value: [
          {
            fechaUltimaComunicacion: {
              $lt: (() => {
                const d = new Date(this.now);
                d.setMonth(d.getMonth() - 1);
                return d.toISOString();
              })(),
            },
          },
        ],
      },
    ],
    filter: {
      field: '$or',
    },
    label: 'Última comunicación',
    selectLabel: 'label',
    selectValue: 'value',
    tipo: 'select',
  };

  //Encendido
  private turnOnOffStatus: IFiltroTabla = {
    elementos: [
      {
        label: 'Encendido',
        filter: [{ 'ultimoReportePeriodico.valores.turnOnOffStatus': true }],
      },
      {
        label: 'Apagado',
        filter: [
          { 'ultimoReportePeriodico.valores.turnOnOffStatus': null },
          { 'ultimoReportePeriodico.valores.turnOnOffStatus': false },
        ],
      },
    ],
    filter: {
      field: '$or',
    },
    label: 'Estado de encendido',
    tipo: 'ngselect',
    selectLabel: 'label',
    selectValue: 'filter',
  };

  //Estado (modelo de 6 estados, calculado por el backend en estado.codigo)
  private estadoLuminaria: IFiltroTabla = {
    elementos: ([0, 1, 2, 3, 4, 5] as CodigoEstadoLuminaria[]).map(
      (codigo) => ({
        label: presentacionEstado(codigo).label,
        filter: [{ 'estado.codigo': codigo }],
      }),
    ),
    filter: {
      field: '$or',
    },
    label: 'Estado',
    rapido: true,
    tipo: 'ngselect',
    selectLabel: 'label',
    selectValue: 'filter',
  };

  //Energía externa

  //Modo
  private modo: IFiltroTabla = {
    elementos: ['Astronómico', 'Fotocélula', 'Manual'],
    filter: {
      field: 'ultimoReportePeriodico.valores.modo',
    },
    label: 'Modo',
    tipo: 'select',
  };

  //Nombre del dispositivo
  private deviceName: IFiltroTabla = {
    elementos: [],
    filter: {
      field: 'deveui',
    },
    label: 'Nombre del dispositivo',
    selectLabel: 'name',
    selectValue: 'deveui',
    tipo: 'ngselect-async',
    asyncFunction: 'dispositivosLorawans',
    searchOn: ['name', 'deveui'],
  };

  //Puesta
  private puesta: IFiltroTabla = {
    elementos: [],
    filter: {
      field: 'idPuesta',
    },
    label: 'Puesta',
    selectLabel: 'identificacion',
    selectValue: '_id',
    tipo: 'ngselect-async',
    asyncFunction: 'puestas',
    searchOn: ['identificacion'],
  };

  //Grupo de luminarias
  private grupo: IFiltroTabla = {
    elementos: [],
    filter: {
      field: 'idsGrupos',
    },
    label: 'Grupo de luminarias',
    selectLabel: 'nombre',
    selectValue: '_id',
    tipo: 'ngselect-async',
    asyncFunction: 'gruposLuminaria',
    searchOn: ['nombre'],
  };

  public filtros: IFiltroTabla[] = [
    this.deviceName,
    this.puesta,
    this.grupo,
    this.estadoLuminaria,
    this.fechaUltimaComunicacion,
    this.turnOnOffStatus,
    this.modo,
  ];

  //Query
  public filter: IFilter<ILuminaria> = {};
  public populate: IPopulate[] = [
    {
      path: 'dispositivo',
      select:
        'name tipo fechaUltimaComunicacion ultimoComando config modeloDispositivo margin ultimoGateway',
    },
    {
      path: 'cliente',
      select: 'nombre',
    },
    {
      path: 'modeloDispositivo',
      select: 'marca modelo',
    },
    {
      path: 'perfilConfig',
      select: 'nombre valores tipoConfig',
    },
  ];
  public query: IQueryParam = {
    filter: JSON.stringify(this.filter),
    populate: JSON.stringify(this.populate),
    sort: 'identificacion',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: true,
    incluirPerfilEfectivo: true,
    // Se podria optimizar con select
  } as IQueryParam;

  public async listar(): Promise<void> {
    this.luminarias$?.unsubscribe();
    this.luminarias$ = this.lista2
      .luminarias(this.query, 30)
      .subscribe(async (data) => {
        // Pre-calcular valores costosos
        const luminarias = data.datos.map(
          (luminaria): ILuminariaExtendida => ({
            ...luminaria,
            // Pre-calcular estado
            estadoCalculado:
              this.luminariasService.determinarEstadoLuminaria(luminaria),
            // Pre-calcular estado de comunicación
            comunicacionCalculada:
              this.luminariasService.calcularEstadoComunicacion(luminaria),
            tieneComandoPendiente:
              this.luminariasService.tieneComandoPendiente(luminaria),
          }),
        );

        await this.calcularPorcentajePerfilAplicado(luminarias);

        if (HelperService.cambiaronLosDatos(this.luminarias, luminarias)) {
          this.luminarias = luminarias;
          this.totalCount = data.totalCount;
        }
      });
  }

  // Calcula `porcentajePerfilAplicado` para cada luminaria con perfil efectivo.
  // Trae las configs deseadas de la página en una sola query (idEntidad =
  // _id del dispositivo lorawan).
  private async calcularPorcentajePerfilAplicado(
    luminarias: ILuminariaExtendida[],
  ): Promise<void> {
    try {
      // Solo las que tienen perfil efectivo y dispositivo asociado.
      const idsDispositivo = luminarias
        .filter((l) => l.perfilEfectivo && l.dispositivo?._id)
        .map((l) => l.dispositivo!._id as string);
      if (!idsDispositivo.length) return;

      const filter = { idEntidad: { $in: idsDispositivo } };
      const res = await this.configsDeseadasService.getFiltered({
        filter: JSON.stringify(filter),
        select: 'idEntidad config',
        includeChildren: true,
        limit: idsDispositivo.length,
      } as IQueryParam);

      const mapaDeseadas = new Map<string, unknown>();
      for (const cd of res?.datos || []) {
        if (cd.idEntidad) mapaDeseadas.set(cd.idEntidad, cd.config);
      }

      for (const l of luminarias) {
        const idEntidad = l.dispositivo?._id;
        if (!l.perfilEfectivo || !idEntidad) continue;
        const deseada = mapaDeseadas.get(idEntidad);
        if (!deseada) continue;
        l.porcentajePerfilAplicado =
          this.luminariasService.porcentajePerfilAplicado(
            l.dispositivo?.config,
            deseada,
            l.dispositivo?.tipo,
          );
      }
    } catch (error) {
      console.error('Error calculando % de perfil aplicado:', error);
    }
  }

  // Acciones

  public async crear() {
    this.navigator.navigate(['crear'], { relativeTo: this.route });
  }

  public abrirImportador() {
    const dialog = this.formularios.abrir(ImportarUbicacionesComponent, {
      tamano: 'mediano',
    });
    dialog.afterClosed().subscribe(async (res) => {
      if (res) {
        await this.listar();
      }
    });
  }

  public recuperarHistorico() {
    this.reportesGenericosService.generarResumenHistorico();
  }

  public async editar(luminaria: ILuminaria) {
    this.navigator.navigate(['editar', luminaria._id], {
      relativeTo: this.route,
    });
  }

  public verDetalles(luminaria: ILuminaria): void {
    this.navigator.navigate([
      'main/luminarias/luminarias/detalles',
      luminaria._id,
    ]);
  }

  public async eliminar(luminaria: ILuminaria) {
    const res = await this.dialogService.confirm(
      'Eliminar luminaria',
      `¿Confirmás eliminar la luminaria ${luminaria.identificacion}?`,
    );
    if (!res) return;
    try {
      await this.service.delete(luminaria._id!);
      this.helper.notifSuccess('Luminaria eliminada');
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  public async cambiarCliente(luminaria: ILuminaria) {
    const dialogRef = this.formularios.abrir(CambiarClienteComponent, {
      tamano: 'mediano',
      data: {
        entidad: luminaria,
        tipoEntidad: 'Luminaria',
      },
    });
    // Se ejecuta cuando el diálogo se cierra
    dialogRef.afterClosed().subscribe(async (resultado) => {
      if (resultado) {
        await this.listar();
      }
    });
  }

  public eventoTecnico(luminaria: ILuminaria) {
    const data: ICrearEditarEventoTecnicoGenericoData = {
      idEntidad: luminaria._id!,
      tipoEvento: 'Evento Técnico Luminaria',
      categoria: 'Luminaria',
      idsCQAET: [this.clientePropio!._id!],
    };
    this.formularios.abrir(CrearEditarEventoTecnicoGenericoComponent, {
      tamano: 'grande',
      data,
    });
  }

  // Exportación multi-hoja. Con `objetivo` exporta una luminaria puntual; sin
  // él, exporta según los filtros activos de la tabla.
  public async exportar(objetivo?: {
    nivel: NivelObjetivo;
    id: string;
    nombre?: string;
  }) {
    const config = await firstValueFrom(
      this.formularios
        .abrir(ExportarLuminariasDialogComponent, {
          tamano: 'chico',
          data: { nivel: objetivo?.nivel ?? 'luminaria' },
        })
        .afterClosed(),
    );
    if (!config) return;

    const scope = objetivo
      ? { nivel: objetivo.nivel, id: objetivo.id }
      : {
          query: {
            filter: this.query.filter,
            includeChildren: true,
          } as IQueryParam,
        };

    const fecha = new Date().toISOString().slice(0, 10);
    const filename = objetivo
      ? `luminaria_${objetivo.nombre ?? objetivo.id}_${fecha}`
      : `luminarias_${fecha}`;
    // El workbook lo arma el backend y puede tardar: se delega al panel de
    // Descargas (background) en vez de bloquear el listado con el spinner.
    // Nombre sin extensión: el panel de Descargas le agrega el `.xlsx`.
    //
    // Una luminaria sola sale en menos de un segundo → request directa. El
    // listado completo son ~80k eventos y ~324k comandos del mes: eso no entra
    // en una request (Cloudflare corta a los 100s), así que va por job
    // asíncrono y el panel de Descargas pollea el estado.
    if (objetivo?.nivel === 'luminaria') {
      this.descargas.agregarDescargaExcel(filename, () =>
        this.luminariasHttpService.exportarLuminariasComoBlob(scope, config),
      );
    } else {
      this.descargas.agregarDescargaJob(filename, {
        crearJob: () =>
          this.luminariasHttpService.crearExportJob(
            scope,
            config,
            `${filename}.xlsx`,
          ),
        consultarEstado: (jobId) =>
          this.luminariasHttpService.getExportJob(jobId),
        descargarArchivo: (jobId) =>
          this.luminariasHttpService.descargarExportJob(jobId),
      });
    }
    this.helper.notifSuccess('Exportación iniciada — ver panel de Descargas');
  }

  public async exportarEventos(luminaria: ILuminaria) {
    const rango = await this.dialogService.dateRange(
      'Exportar eventos',
      'Seleccioná el rango de fechas para exportar los eventos',
    );
    if (!rango) return;

    const filter: IFilter<IEventoGenerico> = {
      idEntidad: luminaria._id,
      fechaCreacion: {
        $gte: rango?.start,
        $lte: rango?.end,
      },
    };

    const populate: IPopulate[] = [
      {
        path: 'luminaria',
        select: 'identificacion',
      },
      {
        path: 'cliente',
        select: 'nombre',
      },
    ];

    const query: IQueryParam = {
      filter: JSON.stringify(filter),
      sort: 'fechaCreacion',
      page: 0,
      limit: 0,
      unlimited: true,
      includeChildren: true,
      populate: JSON.stringify(populate),
    };

    const config = {
      columns: [
        {
          header: 'Cliente',
          key: 'cliente.nombre',
        },
        {
          header: 'Categoría',
          key: 'categoria',
        },
        {
          header: 'Entidad',
          key: 'luminaria.identificacion',
        },
        {
          header: 'Evento',
          key: 'valores.titulo',
        },
        {
          header: 'Detalles',
          key: 'valores.mensaje',
        },
        {
          header: 'Fecha',
          key: 'valores.timestamp',
        },
      ],
      sheetName: 'Eventos',
      autoFilter: true,
    };

    try {
      await this.eventosService.exportar(
        query,
        config,
        luminaria.identificacion,
      );
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  /////////////////////////////////////////////////////////////
  // Tabla

  /** Hora HH:mm en el huso del navegador (sin el -3 fijo de getHora). */
  private hora(v?: string | Date | null): string {
    const f = fechaCelda(v);
    return f ? f.slice(11) : typeof v === 'string' ? v : '';
  }

  /**
   * Comunicación de la luminaria como estado. Mismo cálculo y mismos nombres
   * que el detalle (calcularEstadoComunicacion: tiempo límite de comunicación,
   * nocturna desenergizada de día, frecuencia de reporte).
   */
  private estadoComunicacion(dato: ILuminariaExtendida): IEstadoCelda {
    const c = dato.comunicacionCalculada;
    const texto = c?.tooltip || 'Sin comunicación';
    switch (c?.color) {
      case 'green':
        return { texto, tono: 'ok', icono: 'cloud_done' };
      case 'yellow':
        return { texto, tono: 'aviso', icono: 'schedule' };
      case 'red':
        return { texto, tono: 'neutro', icono: 'cloud_off' };
      case 'black':
        return { texto, tono: 'neutro', icono: 'question_mark' };
      case 'blue':
        return { texto, tono: 'neutro' };
      default:
        return { texto, tono: 'neutro', icono: 'cloud_off' };
    }
  }

  private setColumnas() {
    const columnas: IColumnas<ILuminariaExtendida>[] = [
      // Identificación + Modelo + Estado
      {
        header: {
          label: 'Luminaria',
          sort: 'identificacion',
          sortable: true,
        },
        row: {
          html: (dato) => {
            const tieneUbicacion = !!(dato.ubicacion as IGeoJSONPoint)
              ?.coordinates;

            let html = `<div class="tabla-celda-col">`;

            html += dato.identificacion
              ? `<span class="tabla-principal">${escaparHtml(dato.identificacion)}</span>`
              : `<span class="no-info">Sin identificación</span>`;
            if (!tieneUbicacion) {
              html += `<span class="tabla-secundario no-info">Sin ubicación</span>`;
            }

            // Modelo de luminaria
            const modelo = [
              dato?.modeloDispositivo?.marca,
              dato?.modeloDispositivo?.modelo,
            ]
              .filter(Boolean)
              .join(' ');
            html += modelo
              ? `<span class="tabla-secundario">${escaparHtml(modelo)}</span>`
              : `<span>${estadoHtml({ texto: 'Sin modelo asignado', tono: 'aviso', icono: 'warning' })}</span>`;

            // Estado (6 estados del backend, los mismos del filtro «Estado»)
            const codigo = dato.estadoCalculado?.codigo ?? 0;
            // El pin del estado (la misma imagen del mapa) al lado del nombre
            const pin = dato.estadoCalculado?.icono
              ? `<img class="tabla-pin" src="${escaparHtml(dato.estadoCalculado.icono)}" alt="" />`
              : '';
            html += `<span class="tabla-celda-fila" style="gap:6px;">${pin}${estadoHtml(estadoLuminariaCelda(codigo))}</span>`;

            // Encendido: Encendida/Apagada ya lo dicen; en los demás estados
            // va aparte. Si no se sabe, es falta de dato.
            if (codigo !== 4 && codigo !== 5) {
              const encendida = this.luminariasService.isEncendida(dato);
              html +=
                encendida === true
                  ? `<span class="tabla-secundario">Encendida</span>`
                  : encendida === false
                    ? `<span class="tabla-secundario">Apagada</span>`
                    : `<span class="tabla-secundario no-info">Sin dato de encendido</span>`;
            }

            html += `</div>`;
            return html;
          },
          tooltip: (dato) => {
            const items: string[] = [];
            if (dato.identificacion)
              items.push(
                `<div>Identificación: <strong>${escaparHtml(dato.identificacion)}</strong></div>`,
              );
            if (dato.modeloDispositivo?.marca || dato.modeloDispositivo?.modelo)
              items.push(
                `<div>Modelo: <strong>${escaparHtml(dato.modeloDispositivo?.marca)} ${escaparHtml(dato.modeloDispositivo?.modelo)}</strong></div>`,
              );
            else items.push(`<div>Sin modelo asignado</div>`);

            const estado = dato?.estadoCalculado;
            const config = dato?.dispositivo?.config;
            const alarmas =
              config && typeof (config as any).alarma === 'string'
                ? (config as any).alarma
                : '';

            if (alarmas.trim().length > 0) {
              items.push(
                `<div>Alarmas: <strong>${escaparHtml(alarmas)}</strong></div>`,
              );
            }

            if (!items.length && estado?.ultimoEstado) {
              items.push(`<div>${escaparHtml(estado.ultimoEstado)}</div>`);
            }

            return items.length > 0 ? items.join('') : undefined;
          },
        },
      },

      // Fecha de alta (sorteable por fecha; oculta por defecto)
      {
        header: {
          label: 'Fecha de alta',
          sort: 'fechaCreacion',
          sortable: true,
          hidden: true,
        },
        row: {
          fecha: (dato) => dato.fechaCreacion,
          noData: 'Sin fecha',
        },
      },

      // Perfil efectivo (computado en backend) + nivel del que proviene
      {
        header: {
          label: 'Perfil efectivo',
          sortable: false,
        },
        row: {
          html: (dato) => {
            const pe = dato.perfilEfectivo;
            if (!pe) return '';
            const meta = nivelPerfil(pe.nivel);
            // Nombre de la entidad de origen del perfil (puesta/grupo).
            // A nivel luminaria la entidad es la propia luminaria.
            const fuenteNombre =
              pe.nivel === 'luminaria'
                ? dato.identificacion || 'Esta luminaria'
                : pe.nombreFuente || 'Sin nombre';

            let html = `<div class="tabla-celda-col">`;
            html += `<div class="tabla-linea"><span class="material-symbols-outlined">tune</span>`;
            html += pe.nombre
              ? `<span class="tabla-principal">${escaparHtml(pe.nombre)}</span>`
              : `<span class="no-info">Sin nombre</span>`;
            html += `</div>`;
            html += `<div class="tabla-linea"><span class="material-symbols-outlined">${meta.icon}</span>`;
            html += `<span>${escaparHtml(fuenteNombre)} · ${escaparHtml(meta.label)}</span></div>`;

            // % del perfil aplicado (config deseada vs real)
            const pct = dato.porcentajePerfilAplicado;
            if (pct !== null && pct !== undefined) {
              // Barra de carga: cuánto del perfil ya está aplicado
              html += barraHtml(pct);
            }
            html += `</div>`;
            return html;
          },
          tooltip: (dato) => {
            if (!dato.perfilEfectivo) return undefined;
            const pct = dato.porcentajePerfilAplicado;
            return pct !== null && pct !== undefined
              ? `<div>Perfil aplicado: <strong>${pct.toLocaleString('es-AR')} %</strong></div>`
              : undefined;
          },
          noData: 'Sin perfil',
        },
      },

      // Asignaciones: contenedores a los que pertenece la luminaria
      {
        header: {
          label: 'Asignaciones',
          sortable: false,
        },
        row: {
          html: (dato) => {
            const asignaciones = dato.asignaciones || [];
            if (!asignaciones.length) return '';
            let html = `<div class="tabla-celda-col">`;
            for (const a of asignaciones) {
              const meta = nivelPerfil(a.nivel);
              html += `<div class="tabla-linea" title="${escaparHtml(meta.label)}">`;
              html += `<span class="material-symbols-outlined">${meta.icon}</span>`;
              html += a.nombre
                ? `<span>${escaparHtml(a.nombre)}</span>`
                : `<span class="no-info">Sin nombre</span>`;
              html += `</div>`;
            }
            html += `</div>`;
            return html;
          },
          noData: 'Sin asignaciones',
        },
      },

      // Device + DevEUI + Dirección
      {
        header: {
          label: 'Dispositivo',
          sortable: false,
        },
        row: {
          html: (dato) => {
            const deviceName = dato?.dispositivo?.name ?? '';
            const deveui = dato?.deveui || '';
            const direccion = HelperService.extraerDireccion(dato.direccion);
            const tipoDispositivo =
              dato?.dispositivo?.tipo || dato?.tipoDispositivo || '';
            if (!deviceName && !deveui && !direccion && !tipoDispositivo)
              return '';

            let html = `<div class="tabla-celda-col">`;
            if (deviceName) {
              html += `<div class="tabla-linea"><span class="material-symbols-outlined">router</span><span class="tabla-principal">${escaparHtml(deviceName)}</span></div>`;
            }
            if (tipoDispositivo) {
              html += `<div class="tabla-linea"><span class="material-symbols-outlined">category</span><span>${escaparHtml(tipoDispositivo)}</span></div>`;
            }
            if (deveui) {
              html += `<div class="tabla-linea"><span class="material-symbols-outlined">fingerprint</span><span class="tabla-codigo">${escaparHtml(deveui)}</span></div>`;
            }
            if (direccion) {
              html += `<div class="tabla-linea"><span class="material-symbols-outlined">place</span><span>${escaparHtml(direccion)}</span></div>`;
            }
            html += `</div>`;
            return html;
          },
          tooltip: (dato) => {
            const items: string[] = [];
            if (dato.dispositivo?.name)
              items.push(
                `<div>Dispositivo: <strong>${escaparHtml(dato.dispositivo.name)}</strong></div>`,
              );
            const tipoDisp = dato.dispositivo?.tipo || dato.tipoDispositivo;
            if (tipoDisp)
              items.push(
                `<div>Tipo de dispositivo: <strong>${escaparHtml(tipoDisp)}</strong></div>`,
              );
            if (dato.deveui)
              items.push(
                `<div>DevEUI: <strong>${escaparHtml(dato.deveui)}</strong></div>`,
              );
            if (dato.direccion)
              items.push(
                `<div>Dirección: <strong>${escaparHtml(dato.direccion)}</strong></div>`,
              );
            return items.length > 0 ? items.join('') : undefined;
          },
          noData: 'Sin dispositivo',
        },
      },

      // Comunicación + Señal
      {
        header: {
          label: 'Conectividad',
          sort: 'fechaUltimaComunicacion',
          sortable: true,
        },
        row: {
          html: (dato) => {
            let html = `<div class="tabla-celda-col">`;
            const comunicacion = dato?.comunicacionCalculada;
            html += `<span>${estadoHtml(this.estadoComunicacion(dato))}</span>`;

            const fecha =
              dato.fechaUltimaComunicacion ??
              dato.dispositivo?.fechaUltimaComunicacion;
            if (fecha) {
              html += `<span class="tabla-secundario">${fechaCelda(fecha)} · ${haceCelda(fecha)}</span>`;
            }

            // Señal: las barras y el valor en dB
            const margin = dato?.dispositivo?.margin;
            const senialHtml = this.luminariasService.htmlSenial(
              dato.dispositivo,
              comunicacion?.color !== 'red' && comunicacion?.color !== 'gray',
            );
            if (senialHtml && margin !== undefined && margin !== null) {
              html += `<div class="tabla-celda-fila">${senialHtml}<span class="tabla-secundario">${escaparHtml(String(margin))} dB</span></div>`;
            } else if (senialHtml) {
              html += senialHtml;
            }

            html += `</div>`;
            return html;
          },
          tooltip: (dato) => {
            const items: string[] = [];

            const comunicacion = dato?.comunicacionCalculada;
            if (comunicacion?.tooltip) {
              items.push(`<div>${escaparHtml(comunicacion.tooltip)}</div>`);
            }
            // Fecha con segundos (la celda la muestra sin segundos)
            if (comunicacion?.fecha) {
              items.push(
                `<div>Última comunicación: <strong>${escaparHtml(comunicacion.fecha)}</strong></div>`,
              );
            }

            const level = dato?.dispositivo?.margin;
            if (level !== undefined && level !== null) {
              items.push(`<div>Señal: <strong>${level} dB</strong></div>`);
            }

            return items.length > 0 ? items.join('') : undefined;
          },
        },
      },

      // Modo + Tiempo encendida
      {
        header: {
          label: 'Operación',
          sortable: false,
        },
        row: {
          html: (dato) => {
            let inner = '';
            const linea = (icono: string | null, texto: string, clase = '') =>
              icono
                ? `<div class="tabla-linea"><span class="material-symbols-outlined">${icono}</span><span class="${clase}">${texto}</span></div>`
                : `<div class="tabla-linea"><span class="${clase}">${texto}</span></div>`;

            // Línea 1 (todos los tipos): último cambio on↔off según el estado
            // calculado por el backend (estado.encendida + fechaCambioEncendida).
            // Caso especial: nocturna desenergizada de día (estado.motivo).
            const estado = dato?.estado;
            if (estado?.motivo) {
              const hora = estado.fechaCambioEncendida
                ? ` desde las ${this.hora(estado.fechaCambioEncendida)}`
                : '';
              inner += linea(
                null,
                `${escaparHtml(estado.motivo)}${hora}`,
                'tabla-principal',
              );
            } else if (estado?.encendida != null) {
              const accion = estado.encendida ? 'Encendió' : 'Apagó';
              const iconoAccion = estado.encendida ? 'lightbulb' : 'light_off';
              const hora = estado.fechaCambioEncendida
                ? ` a las ${this.hora(estado.fechaCambioEncendida)}`
                : '';
              inner += linea(
                iconoAccion,
                `${accion}${hora}`,
                'tabla-principal',
              );
            }

            // Líneas de modo, por tipo
            if (dato?.dispositivo?.tipo === 'Luminaria ACTIS FING') {
              const valores = dato?.ultimoReportePeriodico
                ?.valores as IReporteLuminariaACTISEstado;

              // Modo del último cambio reportado
              const modo = valores?.modo || '';
              if (modo) {
                inner += linea(
                  ICONO_MODO[modo] ?? null,
                  `Modo: ${escaparHtml(modo)}`,
                );
              }

              // Modo configurado (según el estado del reporte)
              const cfg = this.luminariasService.modoConfiguradoActis(
                dato?.dispositivo?.config as IDispositivoLuminariaACTIS,
                valores?.turnOnOffStatus,
              );
              if (cfg.label) {
                inner += linea('tune', `Config: ${escaparHtml(cfg.label)}`);
              }
            } else {
              // Wellness / GPE: modo del reporte
              let modo = '';
              if (dato?.dispositivo?.tipo === 'Luminaria Wellness') {
                const valores = dato?.ultimoReportePeriodico
                  ?.valores as IReporteLuminariaWellness;
                modo = valores?.modo || '';
              } else if (dato?.dispositivo?.tipo === 'Luminaria GPE') {
                const valores = dato?.ultimoReportePeriodico
                  ?.valores as IReporteLuminariaGPE;
                modo = valores?.modo || '';
              }

              if (modo) {
                inner += linea(
                  ICONO_MODO[modo] ?? null,
                  escaparHtml(modo),
                  'tabla-principal',
                );
              }
            }

            // Tiempo encendida
            const horas = dato?.tiempoEncendida;
            if (horas !== null && horas !== undefined && !isNaN(horas)) {
              inner += linea(
                'highlight',
                `${Math.trunc(horas).toLocaleString('es-AR')} h encendida`,
              );
            }

            if (!inner) return '';
            return `<div class="tabla-celda-col">${inner}</div>`;
          },
          tooltip: (dato) => {
            const items: string[] = [];

            // Último cambio encendido/apagado (fecha completa; la celda
            // muestra solo la hora)
            const fechaOnOff = dato?.estado?.fechaCambioEncendida;
            if (fechaOnOff) {
              items.push(
                `<div>Último cambio de encendido: <strong>${fechaCelda(fechaOnOff)}</strong></div>`,
              );
            }

            if (dato?.dispositivo?.tipo === 'Luminaria GPE') {
              const valores = dato?.ultimoReportePeriodico
                ?.valores as IReporteLuminariaGPE;
              const modo = valores?.modo;
              if (modo === 'Astronómico') {
                items.push(
                  `<div>Amanecer: <strong>${escaparHtml(this.hora(valores?.horaAmanecer))}</strong></div>`,
                );
                items.push(
                  `<div>Atardecer: <strong>${escaparHtml(this.hora(valores?.horaAtardecer))}</strong></div>`,
                );
              }
            } else if (dato?.dispositivo?.tipo === 'Luminaria ACTIS FING') {
              const valores = dato?.ultimoReportePeriodico
                ?.valores as IReporteLuminariaACTISEstado;
              const modo = valores?.modo;
              if (modo === 'Astronómico') {
                items.push(
                  `<div>Amanecer: <strong>${escaparHtml(this.hora(valores?.horaAmanecer))}</strong></div>`,
                );
                items.push(
                  `<div>Atardecer: <strong>${escaparHtml(this.hora(valores?.horaAtardecer))}</strong></div>`,
                );
              }
              // Detalle de los modos cuando la config es híbrida
              const cfg = this.luminariasService.modoConfiguradoActis(
                dato?.dispositivo?.config as IDispositivoLuminariaACTIS,
                valores?.turnOnOffStatus,
              );
              if (cfg.detalle) {
                items.push(
                  `<div>Modos activos: <strong>${escaparHtml(cfg.detalle)}</strong></div>`,
                );
              }
            }

            const horas = dato?.tiempoEncendida;
            if (horas !== null && horas !== undefined && !isNaN(horas)) {
              items.push(
                `<div>Tiempo encendida: <strong>${Math.trunc(horas).toLocaleString('es-AR')} horas</strong></div>`,
              );
            }

            return items.length > 0 ? items.join('') : undefined;
          },
          noData: 'Sin información de operación',
        },
      },
    ];

    // Estado eléctrico (potencia, voltaje, consumo acumulado, corriente, FP)
    columnas.push({
      header: {
        label: 'Estado eléctrico',
      },
      row: {
        html(dato) {
          const m = medicionesElectricas(dato);
          if (!m) return '';
          const fmt = formatoElectrico;

          let inner = '';
          const p = fmt(m.potencia);
          if (p != null)
            inner += `<div class="tabla-linea"><span class="material-symbols-outlined">bolt</span><span class="tabla-principal">${p} W</span></div>`;
          const secundarios: string[] = [];
          const v = fmt(m.voltaje);
          if (v != null) secundarios.push(`${v} V`);
          const i = fmt(m.corriente);
          if (i != null) secundarios.push(`${i} ${m.unidadCorriente}`);
          const f = fmt(m.fp);
          if (f != null) secundarios.push(`FP ${f}`);
          if (secundarios.length)
            inner += `<span class="tabla-secundario">${secundarios.join(' · ')}</span>`;
          const c = fmt(m.consumoAcum);
          if (c != null)
            inner += `<div class="tabla-linea"><span class="material-symbols-outlined">bolt</span><span>${c} kWh acumulados</span></div>`;

          if (!inner) return '';
          return `<div class="tabla-celda-col">${inner}</div>`;
        },
        tooltip(dato) {
          const m = medicionesElectricas(dato);
          if (!m) return undefined;
          const fmt = formatoElectrico;

          const items: string[] = [];
          const p = fmt(m.potencia);
          if (p != null)
            items.push(`<div>Potencia: <strong>${p} W</strong></div>`);
          const v = fmt(m.voltaje);
          if (v != null)
            items.push(`<div>Voltaje: <strong>${v} V</strong></div>`);
          const c = fmt(m.consumoAcum);
          if (c != null)
            items.push(
              `<div>Consumo acumulado: <strong>${c} kWh</strong></div>`,
            );
          const i = fmt(m.corriente);
          if (i != null)
            items.push(
              `<div>Corriente: <strong>${i} ${m.unidadCorriente}</strong></div>`,
            );
          const f = fmt(m.fp);
          if (f != null)
            items.push(`<div>Factor de potencia: <strong>${f}</strong></div>`);

          return items.length > 0 ? items.join('') : undefined;
        },
        noData: 'Sin mediciones',
      },
    });

    // Último comando
    columnas.push({
      header: {
        label: 'Último comando',
      },
      row: {
        html: (dato) => {
          const comando = dato?.dispositivo?.ultimoComando;
          if (!comando) return '';

          let inner = `<span>${estadoHtml(this.luminariasService.estadoComandoCelda(comando.estado))}</span>`;
          if (comando.descripcion) {
            inner += `<span>${escaparHtml(comando.descripcion)}</span>`;
          }
          const fecha = comando.fechaActualizacion || comando.fechaCreacion;
          if (fecha) {
            inner += `<span class="tabla-secundario">${fechaCelda(fecha)} · ${haceCelda(fecha)}</span>`;
          }

          return `<div class="tabla-celda-col">${inner}</div>`;
        },
        tooltip: (dato) => {
          const comando = dato?.dispositivo?.ultimoComando;
          if (!comando) return undefined;
          const items: string[] = [];
          if (comando.descripcion) {
            items.push(`<div>${escaparHtml(comando.descripcion)}</div>`);
          }
          if (comando.estado) {
            items.push(
              `<div>Estado: <strong>${escaparHtml(this.luminariasService.estiloEstadoComando(comando.estado).texto)}</strong></div>`,
            );
          }
          if (comando.estado === 'Descartado') {
            items.push(
              `<div>El dispositivo estaba sin comunicación al momento de enviar</div>`,
            );
          }
          if (comando.objetivo?.nombre) {
            items.push(
              `<div>Origen: <strong>${escaparHtml(comando.objetivo.nivel)}</strong> · ${escaparHtml(comando.objetivo.nombre)}</div>`,
            );
          }
          const fecha = comando.fechaActualizacion || comando.fechaCreacion;
          if (fecha) {
            items.push(
              `<div>Fecha: <strong>${fechaCelda(fecha)}</strong></div>`,
            );
          }
          return items.length > 0 ? items.join('') : undefined;
        },
        noData: 'Sin comando',
      },
    });

    // Cliente
    if (HelperService.getTipoCliente() !== 'Final') {
      {
        columnas.push({
          header: {
            label: 'Cliente',
            hidden: true,
          },
          row: {
            html: (dato) => this.clienteJerarquia.htmlNombre(dato.cliente),
            tooltip: (dato) =>
              this.clienteJerarquia.tooltipJerarquia(dato.cliente),
          },
        });
      }
    }

    // Acciones
    columnas.push({
      header: {
        label: 'Acciones',
      },
      row: {
        // Mismo orden que antes; Ver detalle primero
        accionesGrouped: [
          // Ver detalle
          {
            tipo: 'material',
            color: 'primary',
            icon: 'visibility',
            tooltip: 'Ver detalle',
            click: (dato) => this.verDetalles(dato),
          },
          // Editar
          {
            tipo: 'material',
            color: 'primary',
            icon: 'edit',
            tooltip: 'Editar',
            click: (dato) => this.editar(dato),
            disabled: () => !this.helper.tienePermiso('Luminarias - Editar'),
          },
          // Eliminar
          {
            tipo: 'material',
            color: 'warn',
            icon: 'delete',
            tooltip: 'Eliminar',
            click: (dato) => this.eliminar(dato),
            disabled: () => !this.helper.tienePermiso('Luminarias - Eliminar'),
          },
          // Reaplicar perfil (GPE + ACTIS, solo con perfil efectivo). NO va
          // dentro de Comandos: no manda un downlink puntual, invalida la config
          // real conocida para que el reconciliador reenvíe todo el perfil.
          // Se usa cuando el dispositivo perdió su config (ej. cambio de firmware).
          {
            tipo: 'material',
            color: 'primary',
            icon: 'published_with_changes',
            tooltip: 'Reaplicar perfil',
            click: (dato) => this.luminariasService.reaplicarPerfil(dato),
            oculta: (dato) =>
              dato?.dispositivo?.tipo === 'Luminaria Wellness' ||
              !dato.perfilEfectivo,
            disabled: (dato) =>
              !!dato.tieneComandoPendiente ||
              !this.helper.tienePermiso('Luminarias - Enviar comandos'),
          },
          // Más acciones
          {
            tipo: 'material',
            color: 'primary',
            icon: 'more_vert',
            tooltip: 'Más acciones',
            children: [
              // Cambiar de cliente
              {
                tipo: 'material',
                color: 'primary',
                icon: 'drive_file_move',
                tooltip: 'Cambiar de cliente',
                click: (dato) => this.cambiarCliente(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Luminarias - Cambiar de cliente'),
              },
              // Servicio técnico
              {
                tipo: 'material',
                color: 'primary',
                icon: 'build',
                tooltip: 'Servicio técnico',
                click: (dato) => this.eventoTecnico(dato),
                oculta: (dato) => !dato.puedeSolicitarServicioTecnico,
                disabled: () =>
                  !this.helper.tienePermiso(
                    'Luminarias - Solicitar servicio técnico',
                  ),
              },
              // Exportar a planilla (esta luminaria)
              {
                tipo: 'material',
                color: 'primary',
                icon: 'table_view',
                tooltip: 'Exportar a planilla',
                click: (dato) =>
                  this.exportar({
                    nivel: 'luminaria',
                    id: dato._id,
                    nombre: dato.identificacion ?? dato.deveui,
                  }),
              },
            ],
          },
          // Comandos
          {
            tipo: 'material',
            color: 'primary',
            icon: 'settings_remote',
            tooltip: 'Comandos',
            // SOLO_COMANDOS_MANUALES: deja solo Encender/Apagar/Pedir GPS (GPE).
            // Ver COMANDOS_MANUALES_VISIBLES y POLITICA_COMANDOS_MANUALES_FRONT.md
            // "Reaplicar perfil" quedó FUERA de este menú (acción de fila propia).
            children: filtrarComandosManuales([
              // Encender
              {
                tipo: 'material',
                color: 'primary',
                icon: 'lightbulb',
                tooltip: 'Encender',
                click: (dato) => this.luminariasService.encenderLuminaria(dato),
                disabled: (dato) =>
                  dato.tieneComandoPendiente ||
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },

              // Apagar
              {
                tipo: 'material',
                color: 'primary',
                icon: 'light_off',
                tooltip: 'Apagar',
                click: (dato) => this.luminariasService.apagarLuminaria(dato),
                disabled: (dato) =>
                  dato.tieneComandoPendiente ||
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              // Cambiar modo
              {
                tipo: 'material',
                color: 'primary',
                icon: 'settings_suggest',
                tooltip: 'Cambiar modo',
                click: (dato) => this.luminariasService.cambiarModo(dato),
                oculta: (dato) =>
                  dato?.dispositivo?.tipo === 'Luminaria Wellness' ||
                  !!dato.perfilEfectivo,
                disabled: (dato) =>
                  dato.tieneComandoPendiente ||
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },

              // Configuración Calendario
              {
                tipo: 'material',
                color: 'primary',
                icon: 'calendar_view_month',
                tooltip: 'Configuración del calendario',
                click: (dato) => this.luminariasService.configCalendario(dato),
                oculta: (dato) =>
                  dato?.dispositivo?.tipo === 'Luminaria Wellness' ||
                  dato?.dispositivo?.tipo === 'Luminaria ACTIS FING' ||
                  !!dato.perfilEfectivo,
                disabled: (dato) =>
                  dato.tieneComandoPendiente ||
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },

              // Consultar calendario
              {
                tipo: 'material',
                color: 'primary',
                icon: 'manage_search',
                tooltip: 'Consultar calendario',
                click: (dato) =>
                  this.luminariasService.consultarConfigCalendario(dato),
                oculta: (dato) =>
                  dato?.dispositivo?.tipo === 'Luminaria Wellness' ||
                  dato?.dispositivo?.tipo === 'Luminaria ACTIS FING',
                disabled: (dato) =>
                  dato.tieneComandoPendiente ||
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              {
                tipo: 'material',
                color: 'primary',
                icon: 'tune',
                tooltip: 'Cambiar configuración',
                click: (dato) => this.luminariasService.createConfig(dato),
                oculta: (dato) =>
                  dato?.dispositivo?.tipo === 'Luminaria Wellness' ||
                  dato?.dispositivo?.tipo === 'Luminaria ACTIS FING' ||
                  !!dato.perfilEfectivo,
                disabled: (dato) =>
                  dato.tieneComandoPendiente ||
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              {
                tipo: 'material',
                color: 'primary',
                icon: 'manage_search',
                tooltip: 'Consultar configuración',
                click: (dato) => this.luminariasService.consultarConfig(dato),
                oculta: (dato) =>
                  dato?.dispositivo?.tipo === 'Luminaria Wellness' ||
                  dato?.dispositivo?.tipo === 'Luminaria ACTIS FING',
                disabled: (dato) =>
                  dato.tieneComandoPendiente ||
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              {
                tipo: 'material',
                color: 'primary',
                icon: 'my_location',
                tooltip: 'Pedir GPS',
                click: (dato) => this.luminariasService.pedirGPS(dato),
                oculta: (dato) =>
                  dato?.dispositivo?.tipo === 'Luminaria Wellness' ||
                  dato?.dispositivo?.tipo === 'Luminaria ACTIS FING',
                disabled: (dato) =>
                  dato.tieneComandoPendiente ||
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              {
                tipo: 'material',
                color: 'primary',
                icon: 'power_settings_new',
                tooltip: 'Resetear',
                click: (dato) => this.luminariasService.reset(dato),
                oculta: (dato) =>
                  dato?.dispositivo?.tipo === 'Luminaria Wellness' ||
                  dato?.dispositivo?.tipo === 'Luminaria ACTIS FING',
                disabled: (dato) =>
                  dato.tieneComandoPendiente ||
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              {
                tipo: 'material',
                color: 'primary',
                icon: 'power_settings_new',
                tooltip: 'Resetear energía',
                click: (dato) => this.luminariasService.resetEnergia(dato),
                oculta: (dato) =>
                  dato?.dispositivo?.tipo === 'Luminaria Wellness' ||
                  dato?.dispositivo?.tipo === 'Luminaria ACTIS FING',
                disabled: (dato) =>
                  dato.tieneComandoPendiente ||
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },

              //Exclusivos de las luminarias ACTIS FING
              //Configuración astronómico/calendario (cambiar el offset de amanecer/atardecer)
              {
                tipo: 'material',
                color: 'primary',
                icon: 'wb_twilight',
                tooltip: 'Configuración astronómica',
                click: (dato) =>
                  this.luminariasService.configActis(dato, 'Offset'),
                oculta: (dato) =>
                  dato?.dispositivo?.tipo === 'Luminaria Wellness' ||
                  dato?.dispositivo?.tipo === 'Luminaria GPE' ||
                  !!dato.perfilEfectivo,
                disabled: (dato) =>
                  dato.tieneComandoPendiente ||
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              //Configuración fotocélula (cambiar los umbrales)
              {
                tipo: 'material',
                color: 'primary',
                icon: 'wb_sunny',
                tooltip: 'Configuración de fotocélula',
                click: (dato) =>
                  this.luminariasService.configActis(dato, 'Treshold'),
                oculta: (dato) =>
                  dato?.dispositivo?.tipo === 'Luminaria Wellness' ||
                  dato?.dispositivo?.tipo === 'Luminaria GPE' ||
                  !!dato.perfilEfectivo,
                disabled: (dato) =>
                  dato.tieneComandoPendiente ||
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              //Setear coordenadas
              {
                tipo: 'material',
                color: 'primary',
                icon: 'my_location',
                tooltip: 'Configuración de coordenadas',
                click: (dato) =>
                  this.luminariasService.configActis(dato, 'Coordinates'),
                oculta: (dato) =>
                  dato?.dispositivo?.tipo === 'Luminaria Wellness' ||
                  dato?.dispositivo?.tipo === 'Luminaria GPE' ||
                  !!dato.perfilEfectivo,
                disabled: (dato) =>
                  dato.tieneComandoPendiente ||
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              //Consultar Config (modo, offset, umbrales, coordinates)
              {
                tipo: 'material',
                color: 'primary',
                icon: 'manage_search',
                tooltip: 'Consultar configuración',
                click: (dato) =>
                  this.luminariasService.consultaActis(dato, 'config'),
                oculta: (dato) =>
                  dato?.dispositivo?.tipo === 'Luminaria Wellness' ||
                  dato?.dispositivo?.tipo === 'Luminaria GPE',
                disabled: (dato) =>
                  dato.tieneComandoPendiente ||
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
              //Consultar Estado Luminaria
              {
                tipo: 'material',
                color: 'primary',
                icon: 'manage_search',
                tooltip: 'Consultar estado',
                click: (dato) =>
                  this.luminariasService.consultaActis(dato, 'estado'),
                oculta: (dato) =>
                  dato?.dispositivo?.tipo === 'Luminaria Wellness' ||
                  dato?.dispositivo?.tipo === 'Luminaria GPE',
                disabled: (dato) =>
                  dato.tieneComandoPendiente ||
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },

              //Consultar Config General Luminaria
              {
                tipo: 'material',
                color: 'primary',
                icon: 'manage_search',
                tooltip: 'Consultar configuración general',
                click: (dato) =>
                  this.luminariasService.consultaActis(dato, 'configGeneral'),
                oculta: (dato) =>
                  dato?.dispositivo?.tipo === 'Luminaria Wellness' ||
                  dato?.dispositivo?.tipo === 'Luminaria GPE',
                disabled: (dato) =>
                  dato.tieneComandoPendiente ||
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },

              //Configurar Reportes Luminaria
              {
                tipo: 'material',
                color: 'primary',
                icon: 'schedule_send',
                tooltip: 'Configurar reportes',
                click: (dato) =>
                  this.luminariasService.configActis(dato, 'Reporte'),
                oculta: (dato) =>
                  dato?.dispositivo?.tipo === 'Luminaria Wellness' ||
                  dato?.dispositivo?.tipo === 'Luminaria GPE' ||
                  !!dato.perfilEfectivo,
                disabled: (dato) =>
                  dato.tieneComandoPendiente ||
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },

              //Configurar ACKs Luminaria
              {
                tipo: 'material',
                color: 'primary',
                icon: 'verified',
                tooltip: 'Configurar ACK',
                click: (dato) =>
                  this.luminariasService.configActis(dato, 'ACK'),
                oculta: (dato) =>
                  dato?.dispositivo?.tipo === 'Luminaria Wellness' ||
                  dato?.dispositivo?.tipo === 'Luminaria GPE' ||
                  !!dato.perfilEfectivo,
                disabled: (dato) =>
                  dato.tieneComandoPendiente ||
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },

              {
                tipo: 'material',
                color: 'primary',
                icon: 'manage_search',
                tooltip: 'Consultar configuración de dimerizado',
                click: (dato) =>
                  this.luminariasService.consultarConfigDimming(dato),
                oculta: (dato) =>
                  dato?.dispositivo?.tipo !== 'Luminaria ACTIS FING' ||
                  !this.luminariasService.perfilTienePerfilesDimming(
                    dato.perfilConfig,
                  ),
                disabled: (dato) =>
                  dato.tieneComandoPendiente ||
                  !this.helper.tienePermiso('Luminarias - Enviar comandos'),
              },
            ]),
          },
        ],
      },
    });

    this.columnas = columnas;
  }

  // Hooks

  async ngOnInit() {
    if (HelperService.getTipoCliente() !== 'Final') {
      this.filtros.push(this.cliente);
      this.filtros.push(this.ancestro);
    }
    this.setColumnas();
    await this.listar();
  }

  async ngOnDestroy() {
    this.luminarias$?.unsubscribe();
  }
}
